














import { Component, Vue, Watch } from 'vue-property-decorator';
import { Footer, FooterApi } from '../../../build/swagger-code-extranet-api-definition';

@Component
export default class ApplicationFooter extends Vue {

  footer: Footer = null;
  loading = true;

  created() {
    this.loadFooter();
    this.addResizeListener();
  }

  mounted() {
    this.updateFooterHeight();
  }

  loadFooter() {
    new FooterApi({ basePath: process.env.VUE_APP_CONTEXT_BASE })
      .getFooter({ credentials: 'same-origin' })
      .then((response) => {
        this.footer = response.data;
        this.loading = false;
      }).catch((reason) => {
                    this.loading = false;
                });
        }

        addResizeListener() {
            window.addEventListener('resize', () => { this.updateFooterHeight(); });
        }

        @Watch('footer')
        resizeFooter() {
            this.$nextTick(this.updateFooterHeight);
        }

        updateFooterHeight() {
            const footer: HTMLElement = this.$refs.footer as HTMLElement;
            if (footer) {
                const height = footer.clientHeight;
                document.body.style.paddingBottom = height + 'px';
            }
        }

    }
